import axios from "axios";

export const apiCMS = axios.create({
    baseURL: 'https://proxy-intra.feagri.unicamp.br:8081/'
});

export const api = axios.create({
    baseURL: 'https://proxy-intra.feagri.unicamp.br'
});

export const apiDac = axios.create({
    baseURL: 'https://proxy-intra.feagri.unicamp.br:8082'
});

// API server-dac V2: endpoints NoSQL modelados para substituir consultas DAC legadas.
export const apiServerDac = axios.create({
    baseURL: 'https://proxy-intra.feagri.unicamp.br:8087'
});

export const apiH = axios.create({
    baseURL: 'https://proxy-intra.feagri.unicamp.br:8085'
});

export const apiJoomla = axios.create({
    baseURL: 'https://proxy-intra.feagri.unicamp.br:8081'
});
